export default __webpack_public_path__ + "static/media/ic_zalo.08f77e71.png";